import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineViewGrid } from "react-icons/hi";
import { TbMotorbike } from "react-icons/tb";
import { HiOutlineShoppingBag } from "react-icons/hi2";
import { PiArmchairLight } from "react-icons/pi";

const FilterButtons = memo(({
    filtroSelecionado,
    onFilterAll,
    onFilterDelivery,
    onFilterBalcao,
    onFilterMesas,
    isMobile = false
}) => {
    const { t } = useTranslation('orders');

    return (
        <div className={`filter-buttons-container ${isMobile ? 'mobile' : 'desktop'}`}>
            <div
                onClick={onFilterAll}
                className={`filter-button filter-button-todos ${filtroSelecionado === "all" ? 'active' : ''} ${isMobile ? 'mobile' : ''}`}
            >
                <div className="filter-button-text">
                    <HiOutlineViewGrid className="filter-icon" />
                    <span>{t('filters.all')}</span>
                </div>
            </div>

            <div
                onClick={onFilterDelivery}
                className={`filter-button filter-button-delivery ${filtroSelecionado === "delivery" ? 'active' : ''} ${isMobile ? 'mobile' : ''}`}
            >
                <div className="filter-button-text">
                    <TbMotorbike className="filter-icon" />
                    <span>{t('filters.delivery')}</span>
                </div>
            </div>

            <div
                onClick={onFilterBalcao}
                className={`filter-button filter-button-balcao ${filtroSelecionado === "balcao" ? 'active' : ''} ${isMobile ? 'mobile' : ''}`}
            >
                <div className="filter-button-text">
                    <HiOutlineShoppingBag className="filter-icon" />
                    <span>{t('filters.counter')}</span>
                </div>
            </div>

            <div
                onClick={onFilterMesas}
                className={`filter-button filter-button-mesas ${filtroSelecionado === "mesas" ? 'active' : ''} ${isMobile ? 'mobile' : ''}`}
            >
                <div className="filter-button-text">
                    <PiArmchairLight className="filter-icon" />
                    <span>{t('filters.tables')}</span>
                </div>
            </div>
        </div>
    );
});

FilterButtons.displayName = 'FilterButtons';

export default FilterButtons;
